import { QUESTIONNAIRE_ANSWER_TYPES } from './questionnaire.enums';


const REASONS_FOR_LEAVING = [
  'Career Growth',
  'Better Income',
  'Job Dissatisfaction',
  'Personal Reasons',
  'Other (Please Specify)',
];

export const NON_SALES_INDUSTRY_PROFESSIONAL_QUESTIONS =
  [
    {
      key: 'Q1',
      number: 1,
      question: 'Are you committed to working with monthly targets?',
      type: QUESTIONNAIRE_ANSWER_TYPES.BOOLEAN,
      is_required: true,
    },
    {
      key: 'Q2',
      number: 2,
      question: 'What is your employment type?',
      type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
      options: ['Permanent', 'Contract', 'Trainee'],
      is_required: true,
    },
    {
      key: 'Q3',
      number: 3,
      question: 'What was the duration of your employment?',
      type: QUESTIONNAIRE_ANSWER_TYPES.DURATION,
      is_required: true,
    },
    {
      key: 'Q4',
      number: 4,
      question: 'What was your reason for leaving your previous role?',
      type: QUESTIONNAIRE_ANSWER_TYPES.MULTI_SELECT,
      options: REASONS_FOR_LEAVING,
      is_required: true,
    },
    {
      key: 'Q5',
      number: 5,
      question: 'What is your reason for seeking a new role?',
      type: QUESTIONNAIRE_ANSWER_TYPES.TEXTAREA,
      placeholder: 'Enter reason',
      is_required: true,
    },
    {
      key: 'Q6',
      number: 6,
      question: 'Have you ever worked in a customer-facing role?',
      type: QUESTIONNAIRE_ANSWER_TYPES.BOOLEAN,
      is_required: true,
    },
    {
      key: 'Q7',
      number: 7,
      question: 'What is your promotion history?',
      type: QUESTIONNAIRE_ANSWER_TYPES.DROPDOWN,
      options: ['Promoted Multiple Times', 'Promoted Once', 'No Promotion'],
      is_required: true,
    },
    {
      key: 'Q8',
      number: 8,
      question: 'How many dependent children do you have?',
      type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
      options: ['0', '1', '2', '3', '4+'],
      is_required: true,
    },
    {
      key: 'Q9',
      number: 9,
      question:
        'How many financial dependents do you support in total (including non-children)?',
      type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
      options: ['0', '1–2', '3–4', '5+'],
      is_required: true,
    },
    {
      key: 'Q10',
      number: 10,
      question: 'What is your primary financial responsibility status?',
      type: QUESTIONNAIRE_ANSWER_TYPES.DROPDOWN,
      options: ['Sole Earner', 'Joint Earner', 'Not Primary Earner'],
      is_required: true,
    },
    {
      key: 'Q11',
      number: 11,
      question:
        'What was your average monthly income during the last 12 months?',
      type: QUESTIONNAIRE_ANSWER_TYPES.DROPDOWN,
      options: [
        'Below 50K',
        '50K–100K',
        '100K–300K',
        '300K–500K',
        '500K–750K',
        'Above 750K',
      ],
      is_required: true,
    },
    {
      key: 'Q12',
      number: 12,
      question: 'What is your current industry and job role?',
      type: QUESTIONNAIRE_ANSWER_TYPES.TEXT,
      placeholder: 'Enter industry and designation',
      is_required: true,
    },
    {
      key: 'Q13',
      number: 13,
      question:
        'What is your involvement in professional, social, community, or voluntary organizations?',
      type: QUESTIONNAIRE_ANSWER_TYPES.MULTI_SELECT,
      options: [
        'Professional Associations',
        'Clubs',
        'Youth Organizations',
        'Charitable Organizations',
        'Sports Clubs',
        'Community Groups',
        'Other (Please specify)',
      ],
      is_required: true,
    },
  ];
